import { IconButton } from '@pets-ui/IconButton/IconButton'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { type JSX, type ReactNode } from 'react'

const styles = stylex.create({
  container: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  rightIcon: {
    color: colors.grey900,
    position: 'absolute',
    right: '20px',
  },
  leftIcon: {
    color: colors.grey900,
    position: 'absolute',
    left: '20px',
  },
})

interface CardTitleWithIconProps {
  leftIcon?: JSX.Element
  rightIcon?: JSX.Element
  onClickLeft?: (event: React.KeyboardEvent | React.MouseEvent) => void
  onClickRight?: (event: React.KeyboardEvent | React.MouseEvent) => void
  title?: ReactNode
}

export function CardTitleWithIcon(props: CardTitleWithIconProps) {
  const { leftIcon, rightIcon, title, onClickLeft, onClickRight } = props
  return (
    <div {...stylex.props(styles.container)}>
      <IconButton fontSize={24} rootStyle={styles.leftIcon} onClick={onClickLeft}>{leftIcon}</IconButton>
      <Text variant="h4">{title}</Text>
      <IconButton fontSize={24} rootStyle={styles.rightIcon} onClick={onClickRight}>{rightIcon}</IconButton>
    </div>
  )
}
